import { render, staticRenderFns } from "./drawerArticoli.vue?vue&type=template&id=577df250"
import script from "./drawerArticoli.vue?vue&type=script&lang=js"
export * from "./drawerArticoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports